import { WorkFileIdentification } from '@/models';

export interface WorkFileIdentificationState {
  identification: WorkFileIdentification | null
}

export const InitialState: WorkFileIdentificationState = {
  identification: null
}
